import styles from "./styles.module.scss";

export const Description = ({ description }) => {
  return (
    <div className={styles.descriptionContainer}>
      <h3>Description</h3>
      <div className={styles.descriptionCard}>{description}</div>
    </div>
  );
};
